<script>
/**
 * BaseExpansion — wrapper fino sobre `v-expansion-panels` para um único painel.
 *
 * Uso típico (acordeão com 1 seção controlável via prop `expanded`):
 *
 *   <BaseExpansion title="Identificação" :expanded="true">
 *     ...conteúdo...
 *   </BaseExpansion>
 *
 * Globally registered via `src/components/_globals.js` (qualquer arquivo
 * `_base-*.vue` é auto-registrado em PascalCase).
 *
 * Props:
 *   - title (String, default ''): texto do cabeçalho do painel.
 *   - expanded (Boolean, default false): se o painel inicia expandido. Pass
 *     `:expanded="true"` explicitamente para abrir por padrão.
 *
 * Slots:
 *   - default: conteúdo renderizado dentro de `v-expansion-panel-content`.
 *   - title: (opcional) substitui o título-texto padrão por markup customizado.
 */
export default {
  name: 'BaseExpansion',
  props: {
    title: {
      type: String,
      default: '',
    },
    // Default `false` per project ESLint rule `vue/no-boolean-default`.
    // Always pass `:expanded="true"` at call sites to start expanded.
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // v-model do v-expansion-panels com `multiple`: array com o índice 0
      // quando expandido, vazio quando colapsado. Mantém estado local após o
      // usuário interagir; a prop `expanded` define apenas o valor inicial.
      panelValue: this.expanded ? [0] : [],
    }
  },
  watch: {
    expanded(newVal) {
      this.panelValue = newVal ? [0] : []
    },
  },
}
</script>

<template>
  <v-expansion-panels
    v-model="panelValue"
    multiple
    class="elevation-0 base-expansion"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <slot name="title">{{ title }}</slot>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<style lang="sass" scoped>
.base-expansion
  background: transparent

  ::v-deep .v-expansion-panel
    background: #FFFFFF
    border: 1px solid #E5E7EB
    border-radius: 8px

  ::v-deep .v-expansion-panel-header
    font-size: 14px
    font-weight: 600
    color: #1F2937
    min-height: 48px
    padding: 12px 16px

  ::v-deep .v-expansion-panel-content__wrap
    padding: 0
</style>
